import { RESET_STATE } from 'store/global/actions';

import { APPRAISAL_SURCHARGE_CRITERIA_ACTION_TYPE } from '../actions';

const initialState = {};

const appraisalSurchargeCriteriaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case APPRAISAL_SURCHARGE_CRITERIA_ACTION_TYPE.GET_APPRAISAL_SURCHARGE_CRITERIA:
    case APPRAISAL_SURCHARGE_CRITERIA_ACTION_TYPE.CREATE_APPRAISAL_SURCHARGE_CRITERIA:
    case APPRAISAL_SURCHARGE_CRITERIA_ACTION_TYPE.EDIT_APPRAISAL_SURCHARGE_CRITERIA:
    case APPRAISAL_SURCHARGE_CRITERIA_ACTION_TYPE.DELETE_APPRAISAL_SURCHARGE_CRITERIA:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default appraisalSurchargeCriteriaReducer;
